import { Box, SvgPath } from '@rbilabs/universal-components';
import { useWindowDimensions } from 'react-native';
import Svg from 'react-native-svg';

interface CurvedBackgroundProps {
  height: number;
  backgroundColor?: string;
}

export const CurvedBackground = ({
  height,
  backgroundColor = Styles.color.white,
}: CurvedBackgroundProps) => {
  const { width } = useWindowDimensions();
  return (
    <Box justifySelf="flex-start" position="absolute">
      <Svg viewBox={`0 0 ${width} ${height}`} width={width} height={height}>
        <SvgPath
          fill={backgroundColor}
          d={`M0 0 H${width} V${height} C${0.8 * width} ${0.7 * height}, ${0.2 * width} ${
            0.7 * height
          }, 0 ${height} Z`}
        />
      </Svg>
    </Box>
  );
};
